export function getInrFormat(
    number: string | number | null,
    symbol = false
): string {
    if (!number) {
        return ''
    }
    const y = `${number}`.split('.')
    const x = y[0].toString()
    let lastThree = x.substring(x.length - 3)
    const otherNumbers = x.substring(0, x.length - 3)
    if (otherNumbers !== '') lastThree = `,${lastThree}`
    let result = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree
    if (symbol) result = `₹ ${result}`
    return result
}
